import { Banknote, CreditCard, Landmark, QrCode } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { money } from '@/components/tables/tableStates';
import { PAYMENT_METHODS } from './shared';

const ICONS = { cash: Banknote, debit: CreditCard, credit: Landmark, transfer: QrCode };

export const PaymentMethodGrid = ({ value, onChange }) => (
  <div className="grid grid-cols-2 gap-2" role="radiogroup" aria-label="Medio de pago" data-testid="payment-method-grid">
    {PAYMENT_METHODS.map(m => {
      const Icon = ICONS[m.value];
      const on = value === m.value;
      return (
        <button key={m.value} type="button" role="radio" aria-checked={on} disabled={m.disabled} onClick={() => onChange(m.value)}
          data-testid={`pay-method-${m.value}`}
          className={`flex flex-col items-center justify-center gap-1 h-20 rounded-xl border text-sm font-semibold transition-colors
            ${on ? 'm-sel' : 'border-border bg-card hover:bg-muted'}
            ${m.disabled ? 'opacity-60 cursor-not-allowed' : ''}`}>
          <Icon className="w-5 h-5" strokeWidth={1.8} />
          <span className="text-center leading-tight px-1">{m.label}</span>
          {m.note && <span className="text-[11px] font-medium text-muted-foreground">{m.note}</span>}
        </button>
      );
    })}
  </div>
);

export const TipPicker = ({ base, tip, setTip, options = [10, 15] }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="tip-picker">
    {options.map(p => {
      const v = Math.round(base * p / 100);
      return (
        <button key={p} type="button" onClick={() => setTip(v)} data-testid={`tip-${p}`}
          className={`h-14 rounded-xl border text-sm ${tip === v ? 'm-sel' : 'border-border hover:bg-muted'}`}>
          <div className="font-semibold">{p}%</div><div className="text-xs">{money(v)}</div>
        </button>
      );
    })}
    <button type="button" onClick={() => setTip(0)} data-testid="tip-none"
      className={`h-14 rounded-xl border text-sm ${tip === 0 ? 'm-sel' : 'border-border hover:bg-muted'}`}>Sin propina</button>
  </div>
);

export const ModernCheckoutDialog = ({ open, onOpenChange, title, total, tip, setTip, method, setMethod, onConfirm, busy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="modern-checkout-dialog">
      <DialogHeader>
        <DialogTitle>Cobrar {title}</DialogTitle>
        <DialogDescription>Elegí el medio de pago y la propina.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <PaymentMethodGrid value={method} onChange={setMethod} />
        <div>
          <p className="text-sm font-semibold mb-2">Propina sugerida</p>
          <TipPicker base={total} tip={tip} setTip={setTip} />
        </div>
        <div className="flex items-end justify-between border-t pt-3">
          <span className="text-sm text-muted-foreground">Monto a cobrar</span>
          <span className="text-3xl font-bold" data-testid="checkout-amount">{money(total + (tip || 0))}</span>
        </div>
      </div>
      <DialogFooter>
        <Button className="w-full h-12 text-base bg-[#2563EB] hover:bg-[#1d4ed8] text-white" disabled={busy || method === 'transfer'}
          onClick={onConfirm} data-testid="checkout-confirm-btn">Cobrar {money(total + (tip || 0))}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
